import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

/**
 * Listens to browser online/offline events and shows a sonner toast
 * when the network status changes.
 */
const useNetworkStatus = () => {
  // Skip the initial mount so we don't toast "You're back online" on page load.
  const isInitialMount = useRef(true);

  useEffect(() => {
    const handleOnline = () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
      toast.success('System Notification', {
        id: 'network-status',
        description: 'You are back online.',
        duration: 4000,
      });
    };

    const handleOffline = () => {
      isInitialMount.current = false;
      toast.warning('System Notification', {
        id: 'network-status',
        description: 'You are currently offline.',
        duration: Infinity,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
};

export default useNetworkStatus;
